import { render } from "./SelectQesTypeModal.vue?vue&type=template&id=774114aa"
import script from "./SelectQesTypeModal.vue?vue&type=script&lang=js"
export * from "./SelectQesTypeModal.vue?vue&type=script&lang=js"
script.render = render

export default script